













































import { Prop, Component, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import Auth from '@aws-amplify/auth';
import API from '@aws-amplify/api';
import Mixin from './mixin';
import OrgInfo from './class/OrgInfo';

@Component
export default class App extends Mixin {
  @Mutation private signIn!: (user: any) => void;
  @Mutation private signOut!: () => void;
  @Mutation private setCognito!: (user: any) => void;
  @Mutation private showOrg!: (id: string) => void;
  @State private title!: string;
  @State private cognito!: string;
  @State private user!: string;
  @State private organization!: OrgInfo[];
  @State private group!: { [index: string]: OrgInfo[]; };
  @State('showOrg') private organizationID!: string;

  private async mounted() {
    if (!this.cognito) {
      const user = await Auth.currentAuthenticatedUser().catch(() => {
        this.logout();
        return null;
      });
      if (user) {
        const userInfo = await API.post('api', '/user', {
          headers: {Authorization: (await Auth.currentSession() as any).idToken.jwtToken },
        });
        this.setCognito(user);
        this.signIn(userInfo);
        this.showOrg('@');
      } else {
        this.$router.push('/');
      }
    }
  }

  private async logout() {
    try {
      await Auth.signOut();
      await this.signOut();
      await this.setCognito(null);
      this.$router.push('/');
      this.msg('ログアウトしました');
    } catch (ex) {
      this.msg(ex);
    }
  }

  get email_verified(): boolean {
    if (this.$store.state.cognito && this.$store.state.cognito.attributes) {
      return this.$store.state.cognito.attributes.email_verified;
    }
    return true;
  }

  get nickname(): string {
    if (this.$store.state.user) {
      return this.$store.state.user.Nickname;
    }
    return '';
  }

  get currentOrg(): OrgInfo {
    return this.organization.filter((v) => v.ID === this.organizationID)[0];
  }

  get currentGroup(): OrgInfo {
    return this.group[this.organizationID].filter((v) => v.ID === this.$route.params.groupid)[0] || this.currentOrg;
  }


}
